import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';

type ReturnedType = any;

export interface sensorMeasureResponses {
  sensorMeasure: string;
  sensorMeasureId: string;
  indexStart: number | null;
  parameterLength: number | null;
  indexEnd: number | null;
}
export interface DeviceDetails {
  sensorTypeId: string;
  sensorType: string;
  sensorMeasureResponse: sensorMeasureResponses[];
}

type inspectionDetailsProps = {
  isLoading: boolean;
  error: string | null;
  data: any;
};

const initialState: inspectionDetailsProps = {
  isLoading: false,
  error: null,
  data: []
};

export const getInspectionView = createAsyncThunk<any, any>(
  'api/get/sensorDetails',
  async (data, thunkApi) => {
    try {
      const deviceid = 'egt3570';
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.GET_INSPECTION}?deviceid=${deviceid}&startdate=1&enddate=1724234986&pageno=1&pagesize=10`,
        signal: data
      });
      return response.data.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: error.response.data?.error,
            severity: 'error'
          })
        );
      }

      return thunkApi.rejectWithValue(error);
    }
  }
);

export const inspectionView = createSlice({
  name: 'Inspection Details',
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getInspectionView.pending, state => {
        state.isLoading = true;
        state.data = [];
      })
      .addCase(
        getInspectionView.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload.data;
          state.error = null;
        }
      )
      .addCase(getInspectionView.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.response?.data.error || 'Something went wrong';
        state.data = [];
      });
  }
});

//action for add inspection
export const setInspectionDetails = createAsyncThunk<any, any>(
  'addinspection',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${URLs.ADD_INSPECTION}`,
        data
      });
      await thunkApi.dispatch(
        updateToast({
          show: true,
          message: 'Inspection Added successfully',
          severity: 'success'
        })
      );
      return response;
    } catch (error) {
      thunkApi.rejectWithValue(error);
    }
  }
);

//slice for add inspection
const addInspectionSlice = createSlice({
  name: 'addinspection',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setInspectionDetails.pending, state => {
      state.isLoading = true;
      state.data = [];
      state.error = null;
    });
    builder.addCase(setInspectionDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      const {
        data: { data }
      } = action?.payload;
      state.data = data;
    });
    builder.addCase(setInspectionDetails.rejected, (state, action: any) => {
      state.isLoading = false;
      state.error = action.payload?.response?.data.error;
    });
  }
});

//action for upload file
export const uploadFileAction = createAsyncThunk<any, any>(
  'uploadfile',
  async (data, thunkApi) => {
    const {
      files: { url, file },
      progress,
      progressCount,
      totalFiles
    } = data;
    try {
      const response = await axios({
        method: 'PUT',
        url: url,
        data: file
      });
      if (response) {
        await progress((prev: any) => prev + 1);
      }
      if (progressCount + 1 === totalFiles) {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: 'Inspection added successfully',
            severity: 'success'
          })
        );
      }
      return response;
    } catch (error) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: 'Upload Failed',
          severity: 'error'
        })
      );
    }
  }
);

export const inspectionSlice = inspectionView.reducer;
export const addInspectionData = addInspectionSlice.reducer;
